export const checkboxTheme = () => `
    &.elc-checkbox-is-disabled {
        opacity: 0.5;
    }
`;
